import * as _ from 'lodash';

export enum FlightEquipment {
	A320 = '320',
	A340 = '340',
	A330 = '330',
	A321 = '321',
	A319 = '319',
	A319NEO = '31N',
	A320NEO = '32N',
	A321NEO = '32Q',
	A330_900NEO = '339',
	A330_200 = '332',
	EMBRAER_190 = 'E90',
	EMBRAER_195 = 'E95'
}

const flightEquipments = [
	FlightEquipment.A320,
	FlightEquipment.A340,
	FlightEquipment.A330,
	FlightEquipment.A321,
	FlightEquipment.A319,
	FlightEquipment.A319NEO,
	FlightEquipment.A320NEO,
	FlightEquipment.A321NEO,
	FlightEquipment.A330_900NEO,
	FlightEquipment.A330_200
];

const isModelNeo = (equipment: FlightEquipment): boolean => {
	return [
		FlightEquipment.A319NEO,
		FlightEquipment.A320NEO,
		FlightEquipment.A321NEO,
		FlightEquipment.A330_900NEO
	].some(equip => Object.is(equipment, equip));
};

const isLongRange = (equipment: FlightEquipment, duration?: number): boolean => {

	switch (equipment) {
		case FlightEquipment.A340:
		case FlightEquipment.A330:
		case FlightEquipment.A330_900NEO:
			return true;
		case FlightEquipment.A321NEO:
			return !_.isNil(duration) && duration >= 5;
		default:
			return false;
	}
};

const spriteLogoByEquipament = (equipment: FlightEquipment, duration?: number): string => {
	switch (equipment) {
		case FlightEquipment.A320NEO:
			return 'airplane--a320neo';
		case FlightEquipment.A321NEO:
			return !_.isNil(duration) && duration >= 5 ? 'airplane--a321LRneo' : 'airplane--a321neo';
		case FlightEquipment.A330_900NEO:
			return 'airplane--a330neo';
		default:
			return '';
	}
};

const description = (equipment: FlightEquipment): string => {
	switch (equipment) {
		case FlightEquipment.A320NEO:
			return 'A320neo';
		case FlightEquipment.A321NEO:
			return 'A321neo';
		case FlightEquipment.A330_900NEO:
			return 'A330-900neo';
		case FlightEquipment.A319:
			return 'A319';
		case FlightEquipment.A320:
			return 'A320';
		case FlightEquipment.A321:
			return 'A321';
		case FlightEquipment.A330:
			return 'A330';
		case FlightEquipment.A340:
			return 'A340';
		case FlightEquipment.A319NEO:
			return 'A319neo';
		case FlightEquipment.A330_200:
			return 'A330-200';
	}
};

const isWifiOnBoard = (equipament: FlightEquipment): boolean => {
	return [
		FlightEquipment.A330_900NEO,
		FlightEquipment.A321NEO
	].some(eq => Object.is(eq, equipament));
};

const getAirplaneStyleDescription = (equipament: FlightEquipment, duration: number): string => {
	switch (equipament) {
		case FlightEquipment.A321NEO:
			return isLongRange(equipament, duration) ? 'A321LR' : 'A321neo';
		case FlightEquipment.A330:
			return 'A330300';
		case FlightEquipment.A330_900NEO:
			return 'A330900NEO';
		case FlightEquipment.A330_200:
			return 'A330200RETROFIT';
		case FlightEquipment.EMBRAER_190:
			return 'EMBRAER_190';
		case FlightEquipment.EMBRAER_195:
			return 'EMBRAER_195';
	}
};

export const FlightEquipmentEnum = {
	allValues: flightEquipments,
	isModelNeo: isModelNeo,
	spriteLogoByEquipament: spriteLogoByEquipament,
	description: description,
	isWifiOnBoard: isWifiOnBoard,
	isLongRange: isLongRange,
	getAirplaneStyleDescription: getAirplaneStyleDescription
};
